import { useEffect, useState } from 'react'

import { Box, Tabs } from '@chakra-ui/react'
import { EDITOR_TOOLS, PanelType } from '@editor/config/constants'
import { INFO_PANEL_PADDING } from '@editor/config/styles'
import { useAppDispatch, useAppSelector } from '@editor/store/app'

import { toggleCollapsedPanel } from '../../store/editor'
import CollapsePanel from '../components/CollapsePanel'
import MaskingRegions from './MaskingRegions'
import Settings from './Settings'

const SettingsPanel = () => {
  // Store
  const dispatch = useAppDispatch()
  const maskRegions = useAppSelector((state) => state.maskPCD.regions)
  const isCollapsed = useAppSelector((state) => state.editor.collapsedPanel.includes(PanelType.Settings))
  const isMaskRegionTool = useAppSelector((state) => state.editor.selectedTool === EDITOR_TOOLS.PCD_TRIM_CUBOID)
  const isSavingArea = useAppSelector((state) => state.page.isSavingArea)

  // State
  const [tabValue, setTabValue] = useState('display')

  useEffect(() => {
    if (isMaskRegionTool) {
      setTabValue('regions')
    } else if (!maskRegions.length) {
      setTabValue('display')
    }
  }, [isMaskRegionTool, maskRegions.length])

  return (
    <Box data-testid="settings-panel" className="panel">
      <CollapsePanel
        title="設定"
        onChange={() => dispatch(toggleCollapsedPanel(PanelType.Settings))}
        isCollapsed={isCollapsed}
        isLoading={isSavingArea}
      >
        <Tabs.Root
          value={tabValue}
          onValueChange={(e) => setTabValue(e.value)}
          w="100%"
          pb={INFO_PANEL_PADDING - 1}
          size="sm"
          variant="panel"
        >
          <Tabs.List width="100%" color="gray2.400">
            <Tabs.Trigger value="display">表示設定</Tabs.Trigger>
            {maskRegions.length || isMaskRegionTool ? <Tabs.Trigger value="regions">注目領域</Tabs.Trigger> : null}
          </Tabs.List>

          <Tabs.Content value="display" pt={2}>
            <Settings />
          </Tabs.Content>
          <Tabs.Content value="regions" pt={2}>
            <MaskingRegions />
          </Tabs.Content>
        </Tabs.Root>
      </CollapsePanel>
    </Box>
  )
}

export default SettingsPanel
